var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { BLANK_NO_USER_IMAGE_URL } from '@/define/consts/assets';
/**
 * ユーザー画像を表示するためのコンポーネント。
 * @param props
 * @constructor
 */
export const UserImage = (props) => {
    const { noImageSrc, src } = props, others = __rest(props, ["noImageSrc", "src"]);
    const noImage = noImageSrc || BLANK_NO_USER_IMAGE_URL;
    return _jsx(ImageBase, Object.assign({ noImageSrc: noImage, src: src || noImage }, others));
};
